import logo from './logo.svg';
import './App.scss';
import { ChakraBaseProvider, extendBaseTheme } from '@chakra-ui/react'
// `@chakra-ui/theme` is a part of the base install with `@chakra-ui/react`
import chakraTheme from '@chakra-ui/theme'
import { SessionProvider } from './SessionProvider';

import {
  StateMachineProvider,
  createStore,
  useStateMachine,
} from 'little-state-machine';


import BuyFlow from './Components/BuyFlow';
import { defaultSession } from './helpers/defaults';



createStore({
  session: {
    ...defaultSession,
  },
});

const theme = extendBaseTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  components: {
    Select: chakraTheme.components.Select,
    Tooltip: chakraTheme.components.Tooltip,
    // Modal: chakraTheme.components.Modal,

    Modal: chakraTheme.components.Modal,
    ModalOverlay: chakraTheme.components.ModalOverlay,
    ModalContent: chakraTheme.components.ModalContent,
    ModalHeader: chakraTheme.components.ModalHeader,
    ModalFooter: chakraTheme.components.ModalFooter,
    ModalBody: chakraTheme.components.ModalBody,
    ModalCloseButton: chakraTheme.components.ModalCloseButton,
  }
});

function App() {
  return (
    <ChakraBaseProvider theme={theme}>
    <StateMachineProvider>
    {/* <SessionProvider> */}
      <BuyFlow/>
    {/* </SessionProvider> */}
    </StateMachineProvider>
    </ChakraBaseProvider>
  );
}

export default App;
